__webpack_require__.p = "/integrations-ngrx/referrals-hub/";